// דירוג מחלקות נוער בישראל — רשימת עבודה לצורכי בחירת משחקים לצילום.
// דרג 1 = מחלקות הנוער המובילות (מועדוני ליגת העל / אקדמיות מובילות)
// דרג 2 = מחלקות חזקות בדרג שמתחת (ליגה לאומית / אקדמיות אזוריות חזקות)
// אפשר לעדכן דירוג של כל מועדון מתוך המערכת (נשמר מקומית בדפדפן).

export const TIER1_CLUBS = [
  'מכבי תל אביב',
  'מכבי חיפה',
  'הפועל באר שבע',
  'בית"ר ירושלים',
  'הפועל תל אביב',
  'מכבי נתניה',
  'מ.ס. אשדוד',
  'בני סכנין',
  'הפועל חיפה',
  'הפועל ירושלים',
  'מכבי פתח תקווה',
  'הפועל פתח תקווה',
  'עירוני קרית שמונה',
  'הפועל חדרה',
  'מכבי בני ריינה',
  'הפועל רמת גן',
  'בני יהודה תל אביב',
  'הפועל כפר סבא',
  'עירוני טבריה',
  'הפועל נוף הגליל',
  'מכבי הרצליה',
  'הפועל רעננה',
  'מכבי יפו',
];

export const TIER2_CLUBS = [
  'הפועל ניר רמת השרון',
  'הפועל רמת השרון',
  'הפועל עכו',
  'הפועל כפר שלם',
  'מכבי אחי נצרת',
  'הפועל ראשון לציון',
  'מכבי קרית ים',
  'הפועל עפולה',
  'הפועל אשקלון',
  'מ.כ. אשקלון',
  'הפועל מרמורק רחובות',
  'הפועל בני לוד',
  'מכבי יבנה',
  'הפועל כפר קאסם',
  'הפועל אזור',
  'מכבי שעריים',
  'הפועל בית שאן',
  'הפועל אשדוד',
  'מכבי קרית גת',
  'הפועל מגדל העמק',
  'הפועל ניר ישראל',
  'מכבי סקציה נס ציונה',
  'הפועל רמלה',
  'הפועל בני מוסמוס',
  'מכבי כפר קאסם',
  'הפועל כפר קאסם נוער',
];

const OVERRIDE_KEY = 'ustar_club_tiers';

export function loadTierOverrides() {
  try { return JSON.parse(localStorage.getItem(OVERRIDE_KEY) || '{}'); }
  catch { return {}; }
}
export function saveTierOverrides(map) {
  try { localStorage.setItem(OVERRIDE_KEY, JSON.stringify(map)); } catch { /* ignore */ }
}

const clean = s => String(s || '').replace(/["'’״׳]/g, '').replace(/\s+/g, ' ').trim();

// מחזיר 1 / 2 / null (לא ידוע). התאמה סלחנית — שם הקבוצה בלוז עשוי לכלול שכבת גיל/שנתון.
export function tierOfClub(name, overrides = {}) {
  const n = clean(name);
  if (!n) return null;
  for (const [club, tier] of Object.entries(overrides)) {
    if (clean(club) && n.includes(clean(club))) return tier;
  }
  const hit = list => list.find(c => { const cc = clean(c); return cc && (n.includes(cc) || cc.includes(n)); });
  if (hit(TIER1_CLUBS)) return 1;
  if (hit(TIER2_CLUBS)) return 2;
  return null;
}
